import { useLayoutEffect, useRef, useState } from 'react';
import { MAX_BOARD_BUMPS } from './boardBump';
import { usePopupTransition } from './popupTransition';

const SlingshotThrowHelp = ({ onOpen }) => {
  const [open, setOpen] = useState(false);
  const { close, popupClass } = usePopupTransition(() => setOpen(false), {
    open,
  });
  const [position, setPosition] = useState({ left: 12, top: 12 });
  const help = useRef(null);
  const button = useRef(null);
  const panel = useRef(null);

  useLayoutEffect(() => {
    if (!open) return undefined;
    const placePanel = () => {
      const anchor = button.current.getBoundingClientRect();
      const popup = panel.current.getBoundingClientRect();
      setPosition({
        left: Math.max(
          12,
          Math.min(
            anchor.right - popup.width,
            window.innerWidth - popup.width - 12
          )
        ),
        top: Math.max(
          12,
          Math.min(
            anchor.top - popup.height - 8,
            window.innerHeight - popup.height - 12
          )
        ),
      });
    };
    const closeOutside = (event) => {
      if (!help.current.contains(event.target)) close();
    };
    const closeOnEscape = (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      event.stopPropagation();
      close();
      button.current.focus({ preventScroll: true });
    };
    placePanel();
    window.addEventListener('resize', placePanel);
    window.addEventListener('scroll', placePanel, true);
    document.addEventListener('pointerdown', closeOutside);
    document.addEventListener('focusin', closeOutside);
    document.addEventListener('keydown', closeOnEscape, true);
    return () => {
      window.removeEventListener('resize', placePanel);
      window.removeEventListener('scroll', placePanel, true);
      document.removeEventListener('pointerdown', closeOutside);
      document.removeEventListener('focusin', closeOutside);
      document.removeEventListener('keydown', closeOnEscape, true);
    };
  }, [open, close]);

  return (
    <div className="coreboundSlingshotThrowHelp" ref={help}>
      <button
        ref={button}
        className="coreboundSlingshotThrowHelpButton"
        type="button"
        aria-label="Throw controls"
        aria-expanded={open}
        aria-controls="coreboundSlingshotThrowHelpPanel"
        onClick={() => {
          if (!open) onOpen?.();
          if (open) close();
          else setOpen(true);
        }}
      >
        <span aria-hidden="true">i</span>
      </button>
      <div
        ref={panel}
        id="coreboundSlingshotThrowHelpPanel"
        className={`coreboundSlingshotThrowHelpPanel ${open ? popupClass : ''}`}
        role="region"
        aria-label="Throw controls"
        hidden={!open}
        style={position}
      >
        <strong>Throw controls</strong>
        <p id="coreboundSlingshotInstructions">
          Drag the die down to build power. Drag left or right to aim, then
          release to throw. Tap a tile for details.
        </p>
        <p>
          Arrow keys aim. Hold and release Space to throw. Escape cancels a
          pull.
        </p>
        <small>{MAX_BOARD_BUMPS} bumps after release.</small>
      </div>
    </div>
  );
};

export default SlingshotThrowHelp;
